import * as React from "react";
import { AddressState, AddressCreationState } from "../lib/model/AddressState";
import { Address } from "../lib/model/Address";
import styled from "styled-components";
import * as _ from "lodash";

const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  font-weight: 300;
  display: inline-block;
`;

export const renderAddress = (
  state: AddressState,
  addresses: Address[]
): JSX.Element => {
  const address = state.id
    ? _.find(addresses, a => a.id === state.id)!
    : state.create;
  if (!!address) {
    const city = address.hasOwnProperty("city")
      ? (address as Address).city
      : (address as AddressCreationState).validatedZip!.city;
    return (
      <Label>
        {address.companyName}
        <br />
        {address.street} {address.houseNumber}, {address.zipCode} {city}
        {!!address.contactName && (
          <>
            <br />
            {address.contactName}
          </>
        )}
        {!!address.contactPhone && <> {address.contactPhone}</>}
        {!!address.extraInfo && (
          <>
            <br />
            {address.extraInfo}
          </>
        )}
      </Label>
    );
  }
  return <></>;
};
